import { Action } from "@lib/titan2-slingo/dist/api/model/enum/Action";
import { GameState } from "@lib/titan2-slingo/dist/api/model/enum/GameState";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ReplayParser } from "@lib/titan2-slingo/dist/api/replay/ReplayParser";
export class GameReplayParser extends ReplayParser {
    parseStakeToSpins(data) {
        const replayData = this.cloneData(data);
        const spinResultsArray = replayData.getDataArray(SlingoConstants.PROPERTY_SPIN_RESULTS);
        const firstNextStakeToSpinIndex = spinResultsArray.findIndex(spinData => {
            const spinResult = spinData.getDataObject("spinResult");
            return spinResult?.getDataArray("nextStakeToSpin");
        });
        if (firstNextStakeToSpinIndex === -1) {
            //no stake to spins, return unmodified data
            return data;
        }
        let wheelSpins = 0;
        const totalStaked = spinResultsArray[firstNextStakeToSpinIndex].getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS).getNumber(SlingoConstants.PROPERTY_TOTAL_STAKED);
        const wheelSpinPrice = spinResultsArray[firstNextStakeToSpinIndex].getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS).getNumber(SlingoConstants.PROPERTY_NEXT_STAKE_TO_SPIN);
        for (let spinIndex = firstNextStakeToSpinIndex; spinIndex < spinResultsArray.length; spinIndex++) {
            const spin = spinResultsArray[spinIndex];
            const spinGameProgress = spin.getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS);
            const spinResult = spin.getDataObject(SlingoConstants.PROPERTY_SPIN_RESULT);
            const stakeToSpin = spinResult.getDataObject(SlingoConstants.PROPERTY_STAKE_TO_SPIN);
            const nextStakeToSpinsFound = spinResult.getDataArray(SlingoConstants.PROPERTY_NEXT_STAKE_TO_SPIN) ?? [];
            const endInCompleteState = spin.getString(SlingoConstants.PROPERTY_STATE) === "COMPLETE";
            const endInFreeSpinState = spin.getString(SlingoConstants.PROPERTY_STATE) === "FREE_SPIN";
            const isFreeSpin = spinResult.getString(SlingoConstants.PROPERTY_SPIN_TYPE) === "FREE";
            const losingNextStakeToSpinsFound = nextStakeToSpinsFound.filter(spinResult => !this.isWinningStakeToSpinResult(spinResult));
            let state = GameState.STANDARD_SPIN.getType();
            if (endInFreeSpinState) {
                state = GameState.FREE_SPIN.getType();
            }
            else if (endInCompleteState) {
                state = GameState.COMPLETE.getType();
            }
            spin.putString(SlingoConstants.PROPERTY_STATE, state);
            const availableActions = endInFreeSpinState ? [Action.SPIN.getType(), Action.COLLECT.getType()] : [Action.STAKE_TO_SPIN.getType(), Action.COLLECT.getType()];
            spin.putStringArray(SlingoConstants.PROPERTY_ACTIONS, availableActions);
            const spinType = isFreeSpin ? "FREE" : "PURCHASE";
            spinResult.putString(SlingoConstants.PROPERTY_SPIN_TYPE, spinType);
            spinGameProgress.putString(SlingoConstants.PROPERTY_COMPLETE_REASON, null);
            spinResult.putPlainObject(SlingoConstants.PROPERTY_NEXT_STAKE_TO_SPIN, null);
            if (stakeToSpin !== null) {
                // any stakeToSpins found (wether in the raw data, or synthesized from losingNextStakeToSpins previously), represent one spin of the wheel, and need the totalStake calculated.
                wheelSpins++;
            }
            spinGameProgress.putNumber(SlingoConstants.PROPERTY_TOTAL_STAKED, totalStaked + (wheelSpins * wheelSpinPrice));
            if (losingNextStakeToSpinsFound.length > 0) {
                // any losing nextStakeToSpins get split into copies of the associated spin-result, each storing one nextStakeToSpins result in its stakeToSpin object
                losingNextStakeToSpinsFound.forEach((stakeToSpinData, newIndex) => {
                    const newSpinData = this.cloneData(spin);
                    const newSpinDataSpinResult = newSpinData.getDataObject(SlingoConstants.PROPERTY_SPIN_RESULT);
                    newSpinDataSpinResult.putDataObject(SlingoConstants.PROPERTY_STAKE_TO_SPIN, stakeToSpinData);
                    spinResultsArray.splice(spinIndex + 1 + newIndex, 0, newSpinData);
                });
            }
        }
        replayData.putDataArray(SlingoConstants.PROPERTY_SPIN_RESULTS, spinResultsArray);
        return replayData;
    }
    parseSpinResultData(spinResultsData, sharedData) {
        return spinResultsData?.map(uniqueData => {
            const spinData = this.cloneData(sharedData);
            const spinResultData = uniqueData.getDataObject(SlingoConstants.PROPERTY_SPIN_RESULT);
            const gameProgressData = uniqueData.getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS);
            const actionsData = uniqueData.getDataObject(SlingoConstants.PROPERTY_ACTIONS);
            const reelSequence = spinResultData.getDataObject(SlingoConstants.PROPERTY_REEL_SEQUENCE);
            const symbols = reelSequence.getStringArray(SlingoConstants.PROPERTY_SYMBOLS);
            reelSequence.putNumberArray(SlingoConstants.PROPERTY_JOKER_INDEXES, this.symbolToReelIndexes(symbols, "J"));
            reelSequence.putNumberArray(SlingoConstants.PROPERTY_SUPER_JOKER_INDEXES, this.symbolToReelIndexes(symbols, "SJ"));
            spinData.putPlainObject(SlingoConstants.PROPERTY_SPIN_RESULT, spinResultData.toObject());
            spinData.putPlainObject(SlingoConstants.PROPERTY_GAME_PROGRESS, gameProgressData.toObject());
            spinData.putPlainObject(SlingoConstants.PROPERTY_ACTIONS, actionsData.toObject());
            spinData.putString(SlingoConstants.PROPERTY_STATE, uniqueData.getString(SlingoConstants.PROPERTY_STATE));
            this.additionalUniqueSpinProperties.forEach(property => {
                if (uniqueData.containsKey(property)) {
                    uniqueData.putPlainObject(property, uniqueData.getDataObject(property).toObject());
                }
            });
            return spinData;
        });
    }
    symbolToReelIndexes(symbols, searchSymbol) {
        return symbols
            .map((symbol, reelIndex) => ({ symbol, reelIndex }))
            .filter(({ symbol }) => symbol === searchSymbol)
            .map(({ reelIndex }) => reelIndex);
    }
    getTotalSpinCount(spinResultsData) {
        return spinResultsData
            .getDataObject(SlingoConstants.PROPERTY_CONFIG)
            .getDataObject(SlingoConstants.PROPERTY_GAME_CONFIG)
            .getNumber(SlingoConstants.PROPERTY_STANDARD_SPINS);
    }
}
//# sourceMappingURL=GameReplayParser.js.map